import { FuseNavigationItem } from '@fleet/model';

export const fleetFlexNavigation: FuseNavigationItem[] = [
  {
    id: 'driver',
    title: 'drivers',
    icon: 'person',
    link: '/driver',

    type: 'basic',
  },
  {
    id: 'job',
    title: 'job',
    icon: 'place',
    link: '/job',
    type: 'basic',
  },
  {
    id: 'organisation',
    title: 'organisations',
    icon: 'business',
    link: '/organisation',

    type: 'basic',
  },
  {
    id: 'traveller',
    title: 'travellers',
    icon: 'hail',
    type: 'basic',
    link: '/traveller',
  },
];
